<template>
  <div class="swaychat-row">
    <textarea ref="input" :value="value" :name="name" :placeholder="label"
    autocomplete="off"
    @change="update($event.target.value)"
    @keypress="triggerSubmit($event)"
    :class="{
      'swaychat-error': error
      }"
    ></textarea>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'name',
    'value',
    'error'
  ],
  methods: {
    update(v) {

      const userInput = v.trim()
      this.$refs.input.value = userInput
      this.$emit('input', userInput)

    },
    triggerSubmit(e) {
      if (e.keyCode == 13) {
        e.preventDefault()
        this.update(e.target.value)
        this.$emit('submit')
      }
    }
  }
}

</script>
